import {gsap} from 'gsap';
function initInformaAnimation() {
    if (!document.querySelector('.informa-hero')) {
        return null;
    }

    const hero = document.querySelector('.informa-hero');
    const breadcrumb = hero.querySelector('.informa-hero__breadcrumb');
    const title = hero.querySelector('.informa-hero__title');
    const meta = hero.querySelector('.informa-hero__meta');
    const mediaCol = document.querySelector('.informa-hero__media-col');

    const tl = gsap.timeline({delay: 0.2});

    if (breadcrumb) {
        tl.fromTo(breadcrumb,
            {opacity: 0, y: 30},
            {opacity: 1, y: 0, duration: 0.8, ease: 'power2.out'}
        );
    }
    if (title) {
        tl.fromTo(title,
            {opacity: 0, y: 80},
            {opacity: 1, y: 0, duration: 1.2, ease: 'power3.out'},
            '-=0.3'
        );
    }
    if (meta) {
        tl.fromTo(meta,
            {opacity: 0, y: 40},
            {opacity: 1, y: 0, duration: 0.8, ease: 'power2.out'},
            '-=0.6'
        );
    }
    if (mediaCol) {
        const bubbles = mediaCol.querySelectorAll('.informa-hero__bubble');
        if (bubbles.length) {
            gsap.set(mediaCol, {opacity: 1});
            tl.to(bubbles,
                {scale: 1, duration: 0.6, ease: 'back.out(1.4)', stagger: {each: 0.05, from: 'random'}},
                '-=0.8'
            );
        } else {
            tl.fromTo(mediaCol,
                {opacity: 0, scale: 0.93, transformOrigin: 'center center'},
                {opacity: 1, scale: 1, duration: 1.4, ease: 'power2.out'},
                '-=1.2'
            );
        }
    }

    // Summary
    const summary = document.querySelector('.informa-summary__text');
    if (summary) {
        gsap.fromTo(summary,
            {opacity: 0, y: 60},
            {
                opacity: 1, y: 0, duration: 1.2, ease: 'power3.out',
                scrollTrigger: {trigger: summary, start: 'top 90%'}
            }
        );
    }

    // Content
    const content = document.querySelector('.informa-content__body');
    if (content) {
        gsap.fromTo(content,
            {opacity: 0, y: 50},
            {
                opacity: 1, y: 0, duration: 1, ease: 'power2.out',
                scrollTrigger: {trigger: content, start: 'top 60%'}
            }
        );
    }

    // Newsletter
    const nlItems = document.querySelectorAll('.informa-newsletter__label, .informa-newsletter__title, .informa-newsletter__sub');
    if (nlItems.length) {
        gsap.fromTo(nlItems,
            {opacity: 0, y: 40},
            {
                opacity: 1, y: 0, duration: 0.9, ease: 'power2.out', stagger: 0.15,
                scrollTrigger: {trigger: '.informa-newsletter', start: 'top 60%'}
            }
        );
    }
}

export {initInformaAnimation};
